---
title: Plan, extras & invoices
parent: Documentation
parentHref: /docs
---

<script>
  import DomainTlds from "@/components/domain-tlds.svelte"
</script>

# Plan, extras, invoices & legal pages

## One plan with everything included

TOBY has one complete plan with no setup fee and no hidden tiers:

- **Monthly or yearly billing:** Choose flexible monthly billing (cancelable monthly at any time) or discounted yearly billing (also payable by invoice / Kauf auf Rechnung). See the [price list](/pricing) for current prices.

Every subscription includes:

- **Your own domain** (<DomainTlds />) — including transferring an existing domain (Domain-Umzug)
- **1 email address** (info@...) with a **15 GB mailbox (Maxi-Postfach)** and unlimited forwarding addresses
- **Up to 15 pages** — created and maintained by chat, voice, or photo upload
- **1 additional language** (2 languages total) with automatic translation when you publish
- **Newsletter** with **1,000 emails / month**
- **Visitor analytics** (privacy-friendly, without cookie banners)
- **Starter pack by mail** (door sticker and A5 QR table stand)
- **Hosting in the EU** with automatic SSL security

## Optional extras

If your business grows beyond the included limits, you can add flexible monthly building blocks at any time under **Settings → Subscription** (see the [price list](/pricing)):

- **+15 GB email storage** (or an additional mailbox)
- **+1 additional website language**
- **+15 additional pages**
- **+5,000 newsletter emails / month**

## Getting a proper business invoice (Website vs. Google Play)

If you run a business, practice, or freelancer account and need a **proper tax-deductible business invoice (ordentliche Rechnung)** with your company name, business address, and VAT (MwSt.) shown separately, please note where you subscribe:

- **Subscribing on the website (tobysite.com via Stripe):** You always receive a **proper business invoice with VAT** from us, addressed to your business. You can download all past invoices and update your company billing address at any time under **Settings → Subscription**.
- **Subscribing in the Android app (Google Play In-App Purchase):** When you subscribe through Google Play, Google processes the payment as the merchant of record and only issues a standard Google Play payment receipt. **We cannot issue a business VAT invoice (ordentliche Rechnung) for subscriptions billed through Google Play.**

> **Tip:** You can subscribe on **tobysite.com** in your browser to get proper Stripe business invoices and still use the TOBY Android and iOS apps with your account at no extra cost.

## Adding your Imprint (Impressum) and Privacy Policy (Datenschutz)

- **Your own legal text:** Because legal requirements depend on your business structure, profession, and country, **TOBY does not generate legal advice or write legal texts (Impressum or Datenschutzerklärung) on its own.**
- **How to add them:** Simply paste your existing Imprint or Privacy Policy text into the chat (or upload it as a Word/PDF document, or ask TOBY to copy it over from your old website) and say *"Put this on our Imprint page."* TOBY will create the pages and link them cleanly in your website footer.
